// Mi Perfil
document.addEventListener("DOMContentLoaded", function () {
    /*const profileForm = document.querySelector(".remax_mi_perfil_form");
    if (!profileForm) {
        console.error("No se encontró el formulario.");
        return;
    }*/
    const disabledFields = document.querySelectorAll(".disabled-field");
    if (disabledFields) {
        disabledFields.forEach((disabledField) => {
            const inputField = disabledField.querySelector("input");
            if (inputField) {
                inputField.setAttribute("readonly", "readonly");
            }
        });
    }
});

// Eliminar item
jQuery(document).ready(function($) {
    let deleteId = null;
    let deletePropiedadId = null;
    let deleteType = null;
    $(".btn-eliminar").on("click", function() {
        deleteId = $(this).data("id");
        deleteType = $(this).data("type");
        if ( deleteType === "hoja-visita" ) {
            deletePropiedadId = $(this).data("propiedad-id");
        }
    });
    $("#confirm-delete").on("click", function() {
        if (!deleteId) return;
        $("#confirm-delete").html('<span class="spinner-border spinner-border-sm"></span> Eliminando...');
        $(this).prop("disabled", true).text("Eliminando...");
        $.ajax({
            url: ajaxUrl.ajaxurl,
            type: "POST",
            data: {
                action: "remax_delete_item",
                id: deleteId,
                type: deleteType
            },
            success: function(response) {
                if (response.success) {
                    $.post(ajaxUrl.ajaxurl, {
                        action: "remax_notification_after_delete_item",
                        message: response.data,
                        propiedadId: deletePropiedadId,
                        type: deleteType
                    }, function( response ) {
                        if (response.success) {
                            window.location.href = response.data;
                        }
                    });
                } else {
                    alert("Error al eliminar el elemento.");
                }
            },
            error: function() {
                alert("Hubo un problema con la solicitud AJAX.");
            },
            complete: function() {
                $("#confirm-delete").prop("disabled", false).text("Eliminar");
                $("#deleteModal").modal("hide");
            }
        });
    });
});

// Gravity Forms radio readonly
document.addEventListener('gform/postRender', (event) => {
    const form = gform.utils.getNode(`#gform_${event.detail.formId}`, document, true);
    const radioButtons = Array.from(gform.utils.getNodes('.gf_readonly input[type=radio]', false, form, true));
 
    radioButtons.forEach(radio => {
        radio.addEventListener('click', (event) => event.preventDefault());
    });
});

// Password toggle
document.addEventListener('DOMContentLoaded', function() {
    const passwordFields = document.querySelectorAll('.gf-password-toggle input');
    passwordFields.forEach(function(field) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('password-toggle-wrapper');
        field.parentNode.insertBefore(wrapper, field);
        wrapper.appendChild(field);
        const toggleBtn = document.createElement('button');
        toggleBtn.setAttribute('type', 'button');
        toggleBtn.classList.add('password-toggle-btn');
        toggleBtn.innerHTML = '👁️';
        wrapper.appendChild(toggleBtn);
        toggleBtn.addEventListener('click', function() {
            if (field.type === 'password') {
                field.type = 'text';
            } else {
                field.type = 'password';
            }
        });
    });
});

// Detect device
document.addEventListener("DOMContentLoaded", function () {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  if (/iPad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    document.body.classList.add('device-ipad');
  } else if (/iPhone/.test(ua)) {
    document.body.classList.add('device-iphone');
  }
});
